import styled from 'styled-components';
import { cssUnitCalc } from 'utils';

export const Item = styled.div<any>`
    flex: none;
    position: absolute;
    overflow: hidden;
    display: inline-block;
`;

export const ChildWrap = styled.div<any>`
    overflow: hidden;
    display: inline-block;
`;

export const Wrapper = styled.div<any>`
    position: relative;
    width: ${p => cssUnitCalc(p.width)};
    height: ${p => cssUnitCalc(p.height)};
`;
